module.exports = __webpack_public_path__ + "static/media/reso.3c493162.svg";